import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, put } from '../services/crud'
import { ApiError, IMarketingProduct, IMarketingProductUpdate } from './typings'

const licensingUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.tenant.tenants}${ServiceConfig.tenant.licensing}`
const updateMarketingProductUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.tenant.tenants}${ServiceConfig.tenant.updateMarketingProduct}`

export const getLicenseInfo = createAsyncThunk<
  IMarketingProduct[],
  void,
  { rejectValue: string }
>('licensing/getInfo', async (_, thunkApi) => {
  const response = await get(licensingUrl)

  if (response.ok) {
    const payload: IMarketingProduct[] = await response.json()
    return payload
  } else {
    const json = await response.json()
    return thunkApi.rejectWithValue(json)
  }
})

export const updateMarketingProduct = createAsyncThunk<
  IMarketingProductUpdate,
  IMarketingProductUpdate,
  { rejectValue: ApiError }
>('licensing/updateMarketingProduct', async (data, thunkApi) => {
  const response = await put(updateMarketingProductUrl, data)
  if (response.ok) {
    return data
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})
